import {
  SCHEDULER_CLEAR,
  SCHEDULER_CLEAR_SCHEDULE_HISTORY,
  SCHEDULER_LOAD_SCHEDULE_HISTORY,
  SCHEDULER_LOAD_SCREENSHOT,
  SCHEDULER_SELECT_SCREENSHOT,
  SCHEDULER_TOGGLE_SCREENSHOT_MODAL,
} from '../actionTypes/scheduler';
import { IScheduleHistoryQuery } from '../../utils/apollo/graphqlSchema';

export const clearSchedulesAction = () => ({
  type: SCHEDULER_CLEAR,
});

export const loadCurrentHistoryAction = (
  scheduleHistory: IScheduleHistoryQuery['scheduleHistory'],
) => ({
  type: SCHEDULER_LOAD_SCHEDULE_HISTORY,
  payload: scheduleHistory,
});

export const clearHistoryAction = () => ({
  type: SCHEDULER_CLEAR_SCHEDULE_HISTORY,
});

export const toggleScreenshotModalAction = (modalState: boolean) => ({
  type: SCHEDULER_TOGGLE_SCREENSHOT_MODAL,
  payload: modalState,
});

export const selectScreenshotAction = (screenshotIndex: number | null) => ({
  type: SCHEDULER_SELECT_SCREENSHOT,
  payload: screenshotIndex,
});

export const loadScreenshotAction = (screenshotUrl: string) => ({
  type: SCHEDULER_LOAD_SCREENSHOT,
  payload: screenshotUrl,
});
